<ng-container>
  <section [ngClass]="{'layout-engine-wrapper ': true, 'layout-scrollable': isScrollable}">
    <div
      *ngFor="let widgets of config;trackBy: trackByFunction"
      [ngStyle]="{'width': widgets?.width + '%'}"
      [ngClass]="'layout-engine-item-wrapper ' + widgets?.styleClass">
   <gen-widget-item
          *ngFor="let widgetItem of widgets.items; trackBy:trackByFunction"
          [item] = widgetItem
          [componentToLoad] ="widgetItem.componentToLoad"
          [ngStyle]= "{'height': widgetItem.height,'width': widgetItem?.width + '%'}"
          [ngClass]="'layout-engine-item '+widgetItem.styleClass"
          id = "id_{{widgetItem.componentToLoad.toLowerCase().split(' ').join('_')}}"
          [disabled]="disabled">
        </gen-widget-item>
    </div>
  </section>
</ng-container>
